// extracted by mini-css-extract-plugin
module.exports = {"container":"_1VM-B","news":"Suafa","content":"_20NFj","aside":"_1Ea5y"};